import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/kerrville")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Kerrville, TX | Texas Made Shade",
      description: "Custom welded awnings, patio & pergola covers, sail shades and ranch tarps for Kerrville & Kerr County. Hill Country shade specialists — free quotes",
      keywords: "pergola covers Kerrville, pergola covers Texas, custom pergola covers Kerrville, aluminum pergola covers Kerrville",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Kerrville, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Kerrville and Kerr County.",
    }),
    scripts: cityHeadScripts("Kerrville", "Kerr County"),
  }),
  component: () => <CityHomePage city="Kerrville" region="Kerr County" />,
});
